import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { setToken } from '@fukuri-admins/utils/common/cookies';

const BEARER_PREFIX = 'Bearer ';
export type LoginFormType = {
  partner_admin_user: {
    email: string;
    password: string;
    code: string;
  };
};

export async function login(formData: LoginFormType): Promise<Response> {
  // NOTE: ログインはヘッダーにトークンを含める必要がないため、fetchWrapperを使用しない
  const response: Response = await fetch(`${REQUEST_API_URL}/partner_admins/sign_in`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
  const authHeader = response.headers.get('Authorization');
  const token = authHeader.substring(BEARER_PREFIX.length);
  setToken(token, {
    path: '/',
    sameSite: 'strict',
  });

  return response;
}
